// Strong at the top for white text; transparent at the bottom so the image stays visible.
export const POST_IMAGE_OVERLAY =
  'linear-gradient(180deg, rgba(78, 26, 239, 0.92) 0%, rgba(78, 26, 239, 0.6) 32%, rgba(78, 26, 239, 0) 100%)';
